// extracted by mini-css-extract-plugin
export default {"wrapper":"Up-z","response":"Vp-z","error":"Wp-z","disabled":"Xp-z","buttons":"Yp-z","feedbackQuestionSection":"Zp-z","yesNoWrapper":"_p-z"};